import { render, staticRenderFns } from "./FormSelectItem.vue?vue&type=template&id=4fe476c7&scoped=true&"
import script from "./FormSelectItem.vue?vue&type=script&lang=js&"
export * from "./FormSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectItem.vue?vue&type=style&index=0&id=4fe476c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe476c7",
  null
  
)

export default component.exports